import { apiBaseUrl } from './config';

const baseUrl = `${apiBaseUrl}/home-carousel`;

export async function getHomeCarouselImages() {
  const r = await fetch(`${baseUrl}/`);
  if (!r.ok) throw { status: r.status };
  return r.json();
}

export async function getAdminHomeCarouselImages(token) {
  const r = await fetch(`${baseUrl}/admin`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}

export async function uploadHomeCarouselImage(token, imageFile) {
  const formData = new FormData();
  formData.append('image', imageFile);

  const r = await fetch(`${baseUrl}/admin`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}

export async function deleteHomeCarouselImage(token, fileName) {
  const encodedFileName = encodeURIComponent(fileName);
  const r = await fetch(`${baseUrl}/admin/${encodedFileName}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!r.ok) {
    let data = null;
    try {
      data = await r.json();
    } catch (_) {
      data = { message: 'No se pudo eliminar la imagen.' };
    }
    throw data;
  }
}
